// extracted by mini-css-extract-plugin
module.exports = {"page-comp":"F_page-comp__nS7Na"};